import { cva } from 'class-variance-authority';

export const clearButtonVariants = cva(
  'inline-flex items-center justify-center w-l h-l shrink-0 rounded-full transition-colors cursor-pointer border-none bg-transparent p-0 bg-clear-button-default hover:bg-clear-button-hover'
);
